/**
 * STYLING: Plain Tailwind ONLY!
 * Variant-count selector (1 / 3 / 5) shown above the generate button.
 */

import { useTranslation } from 'react-i18next';
import { EID } from '@/lib/element-ids.registry';

const OPTIONS = [1, 3, 5];

interface Props {
  value: number;
  onChange: (n: number) => void;
}

export function TextToolVariantSelect({ value, onChange }: Props) {
  const { t } = useTranslation();
  return (
    <div className="text-tool-variant-select flex items-center gap-3">
      <span className="text-xs font-medium text-neutral-600 dark:text-neutral-400">
        {t('textTools.variants.label')}
      </span>
      <div id={EID['text-tool-variants-dropdown']} className="flex gap-1.5">
        {OPTIONS.map((n) => (
          <button
            key={n}
            type="button"
            aria-pressed={value === n}
            onClick={() => onChange(n)}
            className={`px-3 py-1 text-xs rounded-full border ${
              value === n
                ? 'border-primary-500 bg-primary-50 text-primary-700 dark:bg-primary-950/40 dark:text-primary-300'
                : 'border-neutral-300 dark:border-neutral-600 text-neutral-600 dark:text-neutral-400'
            }`}
          >
            {n === 1 ? t('textTools.variants.single') : t('textTools.variants.multi', { n })}
          </button>
        ))}
      </div>
      <span className="text-xs text-neutral-400">{t('textTools.variants.hint')}</span>
    </div>
  );
}
